var map = {
	"./BaseScene": 55,
	"./BaseScene.ts": 55,
	"./Boot": 357,
	"./Boot.ts": 357,
	"./EndlessRunnerScene": 225,
	"./EndlessRunnerScene.ts": 225,
	"./IntroInfoScene": 360,
	"./IntroInfoScene.ts": 360,
	"./OverlayScene": 691,
	"./OverlayScene.ts": 691,
	"./SplashScene": 362,
	"./SplashScene.ts": 362,
	"./SpongeExamplesScene": 692,
	"./SpongeExamplesScene.ts": 692,
	"./TestScene": 363,
	"./TestScene.ts": 363,
	"./_template": 693,
	"./_template.ts": 693,
	"./minigames/CloudCatcherScene": 364,
	"./minigames/CloudCatcherScene.ts": 364,
	"./minigames/LockTheDoorScene": 365,
	"./minigames/LockTheDoorScene.ts": 365,
	"./minigames/MiniGameScene": 142,
	"./minigames/MiniGameScene.ts": 142,
	"./minigames/PasswordRandomiserScene": 366,
	"./minigames/PasswordRandomiserScene.ts": 366,
	"./minigames/TapOutScene": 367,
	"./minigames/TapOutScene.ts": 367
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1798;